const dicts = {
    "abd_whs_delivery_order_type": {
        "n": "",
        "s": [
            {
                "i": 10000443,
                "c": "10",
                "n": "Самовывоз",
                "u": null
            },
            {
                "i": 10000444,
                "c": "20",
                "n": "Доставка иными способами",
                "u": null
            },
            {
                "i": 10000445,
                "c": "30",
                "n": "Транспортная Компания",
                "u": null
            }
        ],
        "i": 1042
    },
    "attribute_status": {
        "n": "",
        "s": [
            {
                "i": 4,
                "c": "0",
                "n": "Приостановлено",
                "u": null
            },
            {
                "i": 5,
                "c": "1",
                "n": "Введено в эксплуатацию",
                "u": null
            }
        ],
        "i": 2
    },
    "buyer_survey_code": {
        "n": "",
        "s": [
            {
                "i": 10000836,
                "c": "buyer_survey_question_01",
                "n": "Исследование удовлетворенности новых клиентов",
                "u": null
            },
            {
                "i": 10000837,
                "c": "buyer_survey_question_02",
                "n": "Исследование удовлетворенности клиента, который вот-вот будет утерян",
                "u": null
            }
        ],
        "i": 1097
    },
    "buy_buyer_bank_config": {
        "n": "",
        "s": [
            {
                "i": 10001622,
                "c": "Альфа-Банк",
                "n": "Альфа-Банк",
                "u": "https://oss.essa.cn/232a3b28-9603-4638-913e-36ec921663be.png"
            },
            {
                "i": 10001623,
                "c": "Банк ВТБ",
                "n": "Банк ВТБ",
                "u": "https://oss.essa.cn/e4708bd8-88be-4fec-ae98-f8618a2959fc.png"
            },
            {
                "i": 10001624,
                "c": "Газпромбанк",
                "n": "Газпромбанк",
                "u": "https://oss.essa.cn/ded289a1-4148-4865-9a14-c8b6ba74a52e.png"
            },
            {
                "i": 10001625,
                "c": "Промсвязьбанк",
                "n": "Промсвязьбанк",
                "u": "https://oss.essa.cn/cd3bd2cc-ba5f-46fe-aebb-b6b22c414ab5.png"
            },
            {
                "i": 10001626,
                "c": "Сбербанк",
                "n": "Сбербанк",
                "u": "https://oss.essa.cn/c5aaaa2b-1aeb-4ec2-b5a9-bfd4c7d0e978.png"
            },
            {
                "i": 10001681,
                "c": "точка банк",
                "n": "точка банк",
                "u": "http://oss.essa.cn/30d8254f-973b-4335-b7f0-999168d799f7.png"
            }
        ],
        "i": 1174
    },
    "buy_buyer_company_type": {
        "n": "",
        "s": [
            {
                "i": 911011,
                "c": "11",
                "n": "Крупный опт/дистрибьютор",
                "u": null
            },
            {
                "i": 911012,
                "c": "12",
                "n": "Мелкий опт/дистрибьютор",
                "u": null
            },
            {
                "i": 911013,
                "c": "13",
                "n": "Оптовая и розничная торговля",
                "u": null
            },
            {
                "i": 911014,
                "c": "14",
                "n": "Гипермаркет",
                "u": null
            },
            {
                "i": 911015,
                "c": "15",
                "n": "Сеть магазинов",
                "u": null
            },
            {
                "i": 911016,
                "c": "16",
                "n": "Розничная торговля/магазин",
                "u": null
            },
            {
                "i": 911017,
                "c": "17",
                "n": "Интернет-магазин",
                "u": null
            },
            {
                "i": 911018,
                "c": "18",
                "n": "Агент по закупкам",
                "u": null
            },
            {
                "i": 911019,
                "c": "19",
                "n": "Другое",
                "u": null
            }
        ],
        "i": 911
    },
    "buy_buyer_position": {
        "n": "",
        "s": [
            {
                "i": 910001,
                "c": "boss",
                "n": "Босс или его родные",
                "u": null
            },
            {
                "i": 910002,
                "c": "shareholder",
                "n": "Миноритарный акционер или партнер",
                "u": null
            },
            {
                "i": 910003,
                "c": "purchase",
                "n": "закупщик компании",
                "u": null
            },
            {
                "i": 910004,
                "c": "other",
                "n": "Другие",
                "u": null
            }
        ],
        "i": 910
    },
    "buy_buyer_sales_amount": {
        "n": "",
        "s": [
            {
                "i": 915001,
                "c": "0",
                "n": "10 000 000 рублей",
                "u": null
            },
            {
                "i": 915002,
                "c": "1",
                "n": "10 000 000 -- 30 000 000 рублей",
                "u": null
            },
            {
                "i": 915003,
                "c": "2",
                "n": "30 000 000 - 50 000 000 рублей",
                "u": null
            },
            {
                "i": 915004,
                "c": "3",
                "n": "50 000 000 - 100 000 000 рублей",
                "u": null
            },
            {
                "i": 915005,
                "c": "4",
                "n": "100 000 000 - 200 000 000 рублей",
                "u": null
            },
            {
                "i": 915006,
                "c": "5",
                "n": "200 000 000 рублей и более",
                "u": null
            }
        ],
        "i": 915
    },
    "buy_buyer_sales_channels": {
        "n": "",
        "s": [
            {
                "i": 912001,
                "c": "offline_store",
                "n": "Физический магазин",
                "u": null
            },
            {
                "i": 912002,
                "c": "internet_sales",
                "n": "Cетевая продажа ( Продавать через интернет )",
                "u": null
            },
            {
                "i": 912003,
                "c": "all",
                "n": "Физический магазин+Продавать через интернет",
                "u": null
            }
        ],
        "i": 912
    },
    "buy_buyer_sales_sku": {
        "n": "",
        "s": [
            {
                "i": 914001,
                "c": "0",
                "n": "Менее 500",
                "u": null
            },
            {
                "i": 914002,
                "c": "1",
                "n": "500 - 1 000",
                "u": null
            },
            {
                "i": 914003,
                "c": "2",
                "n": "1 000–3 000",
                "u": null
            },
            {
                "i": 914004,
                "c": "3",
                "n": "3 000-5 000",
                "u": null
            },
            {
                "i": 914005,
                "c": "4",
                "n": "Свыше 5000",
                "u": null
            }
        ],
        "i": 914
    },
    "buy_customer_intent_level": {
        "n": "",
        "s": [
            {
                "i": 717001,
                "c": "1",
                "n": "C",
                "u": null
            },
            {
                "i": 717002,
                "c": "2",
                "n": "B",
                "u": null
            },
            {
                "i": 717003,
                "c": "3",
                "n": "A",
                "u": null
            }
        ],
        "i": 717
    },
    "claim_demage_order_damage_code": {
        "n": "",
        "s": [
            {
                "i": 927001,
                "c": "quantity",
                "n": "Не хватает позиций",
                "u": null
            },
            {
                "i": 927002,
                "c": "parts",
                "n": "Не хватает деталей",
                "u": null
            },
            {
                "i": 927003,
                "c": "colour",
                "n": "Цвет или кол-во не соответствуют заказу",
                "u": null
            },
            {
                "i": 927004,
                "c": "goods_bad",
                "n": "Позиция сломана",
                "u": null
            },
            {
                "i": 927005,
                "c": "package_bad",
                "n": "Упаковка испорчена",
                "u": null
            },
            {
                "i": 927006,
                "c": "wrong_delivery",
                "n": "Фабрика отправила не тот товар",
                "u": null
            }
        ],
        "i": 927
    },
    "claim_demage_order_fin_handle_status": {
        "n": "",
        "s": [
            {
                "i": 928001,
                "c": "to_de_handle",
                "n": "Обрабатывается",
                "u": null
            },
            {
                "i": 928002,
                "c": "handled",
                "n": "Обработано",
                "u": null
            }
        ],
        "i": 928
    },
    "claim_demage_order_status": {
        "n": "",
        "s": [
            {
                "i": 923001,
                "c": "1",
                "n": "Ожидание проверки",
                "u": null
            },
            {
                "i": 10000485,
                "c": "7",
                "n": "Русский перевод",
                "u": null
            },
            {
                "i": 10000486,
                "c": "8",
                "n": "Закрыто",
                "u": null
            },
            {
                "i": 923002,
                "c": "2",
                "n": "Ожидание компенсации",
                "u": null
            },
            {
                "i": 923003,
                "c": "3",
                "n": "Отклонено",
                "u": null
            },
            {
                "i": 923004,
                "c": "4",
                "n": "Отменить",
                "u": null
            },
            {
                "i": 923005,
                "c": "5",
                "n": "Компенсировано",
                "u": null
            },
            {
                "i": 923006,
                "c": "6",
                "n": "Недействительно",
                "u": null
            }
        ],
        "i": 923
    },
    "claim_demage_order_status_mg": {
        "n": "",
        "s": [
            {
                "i": 10000476,
                "c": "1",
                "n": "Русский перевод",
                "u": null
            },
            {
                "i": 10000478,
                "c": "3",
                "n": "Отклонено",
                "u": null
            },
            {
                "i": 10000480,
                "c": "5",
                "n": "Компенсировано",
                "u": null
            },
            {
                "i": 10000482,
                "c": "7",
                "n": "Ожидает обработки",
                "u": null
            },
            {
                "i": 10000477,
                "c": "2",
                "n": "Одобрено",
                "u": null
            },
            {
                "i": 10000479,
                "c": "4",
                "n": "Отменено",
                "u": null
            },
            {
                "i": 10000481,
                "c": "6",
                "n": "Истек срок действия",
                "u": null
            },
            {
                "i": 10000483,
                "c": "8",
                "n": "Закрыто",
                "u": null
            },
            {
                "i": 10000484,
                "c": "9",
                "n": "Инициировано",
                "u": null
            }
        ],
        "i": 1048
    },
    "claim_demage_order_type": {
        "n": "",
        "s": [
            {
                "i": 924001,
                "c": "arrive_late",
                "n": "Гарантия поставки",
                "u": null
            },
            {
                "i": 924002,
                "c": "damaged",
                "n": "Гарантия качества",
                "u": null
            },
            {
                "i": 924003,
                "c": "disable",
                "n": "Гарантия оптимальной цены",
                "u": null
            }
        ],
        "i": 924
    },
    "ddp_abd_buyer_storage_status": {
        "n": "",
        "s": [
            {
                "i": 4680195,
                "c": "10",
                "n": "未付款",
                "u": null
            },
            {
                "i": 4680196,
                "c": "20",
                "n": "部分付款",
                "u": null
            },
            {
                "i": 4680197,
                "c": "30",
                "n": "待出库",
                "u": null
            }
        ],
        "i": 948
    },
    "ddp_sticker_tort_remark": {
        "n": "",
        "s": [
            {
                "i": 1018001,
                "c": "1",
                "n": "Нарушение авторского права на тип товара",
                "u": null
            },
            {
                "i": 1018002,
                "c": "2",
                "n": "Нарушение авторского права на товарный знак",
                "u": null
            },
            {
                "i": 1018003,
                "c": "3",
                "n": "Нарушение  авторского права на сочетания зарегистрированных цветов",
                "u": null
            },
            {
                "i": 1018004,
                "c": "4",
                "n": "Нарушение авторского права шрифта надписи на товаре",
                "u": null
            }
        ],
        "i": 1018
    },
    "essaone_buyer_label_type": {
        "n": "",
        "s": [
            {
                "i": 10000783,
                "c": "10",
                "n": "Новый клиент",
                "u": null
            },
            {
                "i": 10000784,
                "c": "20",
                "n": "Растущий клиент",
                "u": null
            },
            {
                "i": 10000785,
                "c": "30",
                "n": "Постоянный клиент",
                "u": null
            },
            {
                "i": 10000786,
                "c": "40",
                "n": "Почти потерянный клиент",
                "u": null
            },
            {
                "i": 10000787,
                "c": "50",
                "n": "Уже утерянный клиент",
                "u": null
            }
        ],
        "i": 1086
    },
    "essaone_new_buyer_label_type": {
        "n": "",
        "s": [
            {
                "i": 10000788,
                "c": "10",
                "n": "первый контакт ",
                "u": null
            },
            {
                "i": 10000904,
                "c": "80",
                "n": "Повторной активации",
                "u": null
            },
            {
                "i": 10000789,
                "c": "20",
                "n": "продолжать диалог (Целевой клиент)",
                "u": null
            },
            {
                "i": 10000790,
                "c": "21",
                "n": "продолжать диалог (нецелевые клиенты)",
                "u": null
            },
            {
                "i": 10000791,
                "c": "30",
                "n": "товар в корзине",
                "u": null
            },
            {
                "i": 10000792,
                "c": "40",
                "n": "1-ый заказ ",
                "u": null
            },
            {
                "i": 10000793,
                "c": "50",
                "n": "депозит оплачен",
                "u": null
            },
            {
                "i": 10000794,
                "c": "60",
                "n": " сделка не состоялась",
                "u": null
            },
            {
                "i": 10000795,
                "c": "70",
                "n": "Неудача в сближении ",
                "u": null
            }
        ],
        "i": 1087
    },
    "essaone_not_transacted_reason_type": {
        "n": "",
        "s": [
            {
                "i": 10000815,
                "c": "10",
                "n": "Не нужно. У нас поменялись потребности, пока не покупаем",
                "u": null
            },
            {
                "i": 10000816,
                "c": "20",
                "n": "Дорогая цена.",
                "u": null
            },
            {
                "i": 10000817,
                "c": "30",
                "n": "Перешел к конкуренту.",
                "u": null
            },
            {
                "i": 10000818,
                "c": "40",
                "n": "Решил отложить покупку. ",
                "u": null
            },
            {
                "i": 10000819,
                "c": "50",
                "n": "Другая причина. ",
                "u": null
            }
        ],
        "i": 1093
    },
    "fin_in_out_type": {
        "n": "",
        "s": [
            {
                "i": 504001,
                "c": "1",
                "n": "Войти",
                "u": null
            },
            {
                "i": 504002,
                "c": "-1",
                "n": "Выйти",
                "u": null
            }
        ],
        "i": 504
    },
    "fin_refund_from_type": {
        "n": "",
        "s": [
            {
                "i": 925001,
                "c": "arrive_late",
                "n": "Гарантия поставки",
                "u": null
            },
            {
                "i": 925005,
                "c": "title_to_goods",
                "n": " Отказ от права на товар",
                "u": null
            },
            {
                "i": 925006,
                "c": "cash_out",
                "n": "Вывод средств клиентом",
                "u": null
            },
            {
                "i": 925002,
                "c": "damaged",
                "n": "Гарантия качества",
                "u": null
            },
            {
                "i": 925003,
                "c": "disable",
                "n": "Гарантия оптимальной цены",
                "u": null
            },
            {
                "i": 925004,
                "c": "goods_cancel",
                "n": "Отмена позиции",
                "u": null
            }
        ],
        "i": 925
    },
    "fin_remittance_item_pay_type": {
        "n": "",
        "s": [
            {
                "i": 500001,
                "c": "BANK_TRANSFER",
                "n": "Банковский трансфер",
                "u": null
            },
            {
                "i": 500002,
                "c": "LETTER_OF_CREDIT",
                "n": "Аккредитив",
                "u": null
            },
            {
                "i": 500003,
                "c": "COMMERCIAL_INVOICE",
                "n": "Торговая счёт-фактура",
                "u": null
            },
            {
                "i": 500004,
                "c": "CASH",
                "n": "Наличные",
                "u": null
            }
        ],
        "i": 500
    },
    "fin_remittance_item_state": {
        "n": "",
        "s": [
            {
                "i": 618001,
                "c": "TO_BE_CONFIRM",
                "n": "Ожидает подтверждения",
                "u": null
            },
            {
                "i": 618002,
                "c": "CONFIRMED",
                "n": "Уже утверждено",
                "u": null
            }
        ],
        "i": 618
    },
    "fx_commission_wallet_item_biz_type": {
        "n": "",
        "s": [
            {
                "i": 997001,
                "c": "BUYER",
                "n": "Приглашенные клиенты",
                "u": null
            },
            {
                "i": 997002,
                "c": "DISTRIBUTOR_BUYER",
                "n": "Клиенты, приглашенные дистрибьюторами",
                "u": null
            },
            {
                "i": 997003,
                "c": "ORDER",
                "n": "Другое",
                "u": null
            },
            {
                "i": 997004,
                "c": "OTHER",
                "n": "Другое",
                "u": null
            },
            {
                "i": 997005,
                "c": "WITHDRAW",
                "n": "Снятие наличных денег",
                "u": null
            }
        ],
        "i": 997
    },
    "fx_invitation_buyer_status": {
        "n": "",
        "s": [
            {
                "i": 10000001,
                "c": "0",
                "n": "Выполняется аутентификация",
                "u": null
            },
            {
                "i": 10000002,
                "c": "1",
                "n": "Аутентификация не прошла",
                "u": null
            },
            {
                "i": 10000003,
                "c": "2",
                "n": "Аутентифицированный",
                "u": null
            }
        ],
        "i": 1000
    },
    "fx_user_status": {
        "n": "",
        "s": [
            {
                "i": 816001,
                "c": "VALID",
                "n": "Включено",
                "u": null
            },
            {
                "i": 816002,
                "c": "INVALID",
                "n": "Деактивировано",
                "u": null
            },
            {
                "i": 816003,
                "c": "NOT_ENABLED",
                "n": "Не активирован",
                "u": null
            }
        ],
        "i": 816
    },
    "fx_user_type": {
        "n": "",
        "s": [
            {
                "i": 908001,
                "c": "0",
                "n": "Комиссия при регистрации",
                "u": null
            },
            {
                "i": 908002,
                "c": "1",
                "n": "Комиссия по заказу",
                "u": null
            }
        ],
        "i": 908
    },
    "im_type": {
        "n": "",
        "s": [
            {
                "i": 372,
                "c": "2",
                "n": "вотсап",
                "u": null
            },
            {
                "i": 373,
                "c": "3",
                "n": "скайп",
                "u": null
            },
            {
                "i": 374,
                "c": "4",
                "n": "вичат",
                "u": null
            },
            {
                "i": 375,
                "c": "5",
                "n": "Электронная почта",
                "u": null
            },
            {
                "i": 377,
                "c": "7",
                "n": "мобильные телефоны",
                "u": null
            },
            {
                "i": 380,
                "c": "10",
                "n": "Facebook",
                "u": null
            },
            {
                "i": 396,
                "c": "11",
                "n": "Twitter",
                "u": null
            },
            {
                "i": 10000649,
                "c": "13",
                "n": "LinkedIn",
                "u": null
            },
            {
                "i": 10000650,
                "c": "14",
                "n": "Line",
                "u": null
            },
            {
                "i": 10000651,
                "c": "15",
                "n": "Telegram",
                "u": null
            },
            {
                "i": 10000704,
                "c": "16",
                "n": "vkontakte",
                "u": null
            }
        ],
        "i": 46
    },
    "is_corporate_enterprise": {
        "n": "",
        "s": [
            {
                "i": 10000796,
                "c": "0",
                "n": "Hет",
                "u": null
            },
            {
                "i": 10000797,
                "c": "1",
                "n": "Да",
                "u": null
            }
        ],
        "i": 1088
    },
    "is_ka_buyer": {
        "n": "",
        "s": [
            {
                "i": 10000800,
                "c": "0",
                "n": "Не KA клиент",
                "u": null
            },
            {
                "i": 10000801,
                "c": "1",
                "n": "KA клиент",
                "u": null
            }
        ],
        "i": 1090
    },
    "is_one_box": {
        "n": "",
        "s": [
            {
                "i": 10000798,
                "c": "0",
                "n": "Hет",
                "u": null
            },
            {
                "i": 10000799,
                "c": "1",
                "n": "Да",
                "u": null
            }
        ],
        "i": 1089
    },
    "po_item_sticker_icon_code": {
        "n": "",
        "s": [
            {
                "i": 10001045,
                "c": "01",
                "n": "eac",
                "u": "https://oss.essa.cn/sticker_icon_01.png"
            },
            {
                "i": 10001046,
                "c": "002",
                "n": "易碎品",
                "u": "https://oss.essa.cn/sticker_icon_02.png"
            },
            {
                "i": 10001047,
                "c": "003",
                "n": "PVC03",
                "u": "https://oss.essa.cn/sticker_icon_03.png"
            },
            {
                "i": 10001048,
                "c": "004",
                "n": "PAP20",
                "u": "https://oss.essa.cn/sticker_icon_04.png"
            },
            {
                "i": 10001049,
                "c": "005",
                "n": "可扔垃圾桶",
                "u": "https://oss.essa.cn/sticker_icon_05.png"
            },
            {
                "i": 10001050,
                "c": "006",
                "n": "PE-LD04",
                "u": "https://oss.essa.cn/sticker_icon_06.png"
            },
            {
                "i": 10001051,
                "c": "007",
                "n": "可回收",
                "u": "https://oss.essa.cn/sticker_icon_07.png"
            },
            {
                "i": 10001671,
                "c": "008",
                "n": "PET01",
                "u": "https://oss.essa.cn/8f09badc-49f9-46fb-9fdc-0fc83428f34f.jpg"
            },
            {
                "i": 10001672,
                "c": "009",
                "n": "PAP21",
                "u": "https://oss.essa.cn/fa6bdea8-0349-44a4-87cc-5abfbd018a5b.png"
            },
            {
                "i": 10001673,
                "c": "010",
                "n": "PAP22",
                "u": "https://oss.essa.cn/bd2ef938-640c-4410-8b44-5fa1db7afd28.png"
            },
            {
                "i": 10001674,
                "c": "011",
                "n": "PP05",
                "u": "https://oss.essa.cn/656e99f1-25b3-402f-b7c7-2507223b75e5.png"
            },
            {
                "i": 10001675,
                "c": "PC",
                "n": "PC",
                "u": "https:////oss.essa.cn/903b133d-22de-49f1-a8a1-15e124687518.png"
            },
            {
                "i": 10001676,
                "c": "FOR51",
                "n": "FOR51",
                "u": "https:////oss.essa.cn/1ba5f48e-92ba-4b29-a20d-7220d162de78.png"
            },
            {
                "i": 10001677,
                "c": "ALU41",
                "n": "ALU41",
                "u": "https:////oss.essa.cn/3f9d9de2-158c-4fd9-929b-69d96af322bb.png"
            }
        ],
        "i": 1158
    },
    "prd_goods_copyright": {
        "n": "",
        "s": [
            {
                "i": 107001,
                "c": "1",
                "n": "Собственные авторские права",
                "u": null
            },
            {
                "i": 107002,
                "c": "2",
                "n": "Сторонние авторские прав",
                "u": null
            },
            {
                "i": 107003,
                "c": "3",
                "n": "Нет авторизации",
                "u": null
            },
            {
                "i": 107004,
                "c": "4",
                "n": "товар высшего качества",
                "u": null
            }
        ],
        "i": 107
    },
    "prd_goods_out_box_unit": {
        "n": "",
        "s": [
            {
                "i": 108010,
                "c": "10",
                "n": "кор.",
                "u": null
            }
        ],
        "i": 108
    },
    "sale_po_claim_demage_order_claim_type": {
        "n": "",
        "s": [
            {
                "i": 10000474,
                "c": "10",
                "n": "Купон",
                "u": null
            },
            {
                "i": 10000475,
                "c": "20",
                "n": "Наличные",
                "u": null
            }
        ],
        "i": 1047
    },
    "sale_po_ddp_status_buyer": {
        "n": "",
        "s": [
            {
                "i": 1000398,
                "c": "-10",
                "n": "Заказ аннулирован",
                "u": null
            },
            {
                "i": 1000399,
                "c": "10",
                "n": "Ожидается оплата депозита",
                "u": null
            },
            {
                "i": 1000401,
                "c": "20",
                "n": "Депозит уже оплачен, заказ в обработке",
                "u": null
            },
            {
                "i": 1000402,
                "c": "40",
                "n": "Заказ в производстве",
                "u": null
            },
            {
                "i": 1000413,
                "c": "41",
                "n": "Ваш заказ произведён",
                "u": null
            },
            {
                "i": 1000403,
                "c": "45",
                "n": "На проверке качества",
                "u": null
            },
            {
                "i": 1000404,
                "c": "50",
                "n": "Ожидается получение на склад в Китае",
                "u": null
            },
            {
                "i": 1000405,
                "c": "60",
                "n": "В процессе загрузки контейнера",
                "u": null
            },
            {
                "i": 1000406,
                "c": "70",
                "n": "Загрузка завершена",
                "u": null
            },
            {
                "i": 1000407,
                "c": "80",
                "n": "Прошёл таможню",
                "u": null
            },
            {
                "i": 1000408,
                "c": "90",
                "n": "Товар отправлен",
                "u": null
            },
            {
                "i": 1000414,
                "c": "100",
                "n": "Ожидается оплата закрывающего платежа",
                "u": null
            },
            {
                "i": 1000415,
                "c": "105",
                "n": "Закрывающий платеж уже оплачен, ожидается отгрузка товара",
                "u": null
            },
            {
                "i": 1000400,
                "c": "110",
                "n": "Заказ выполнен",
                "u": null
            },
            {
                "i": 4680243,
                "c": "101",
                "n": "Закрывающий платеж уже оплачен",
                "u": null
            },
            {
                "i": 4680244,
                "c": "102",
                "n": "На складе, ожидается окончательная оплата",
                "u": null
            },
            {
                "i": 4680245,
                "c": "106",
                "n": "На складе, ожидается отгрузка товара",
                "u": null
            },
            {
                "i": 10001715,
                "c": "107",
                "n": "Обработка маркировки",
                "u": null
            }
        ],
        "i": 931
    },
    "sale_po_ddp_status_buyer_activity": {
        "n": "",
        "s": [
            {
                "i": 4680190,
                "c": "-10",
                "n": "Заказ аннулирован",
                "u": null
            },
            {
                "i": 4680191,
                "c": "10",
                "n": "Ожидание оплаты",
                "u": null
            },
            {
                "i": 4680192,
                "c": "105",
                "n": "Оплачено, ожидание забора товара",
                "u": null
            },
            {
                "i": 4680193,
                "c": "110",
                "n": "Выполнено",
                "u": null
            }
        ],
        "i": 947
    },
    "sale_po_status": {
        "n": "",
        "s": [
            {
                "i": 300001,
                "c": "-10",
                "n": "Отменено",
                "u": null
            },
            {
                "i": 4680194,
                "c": "105",
                "n": "已入库",
                "u": null
            },
            {
                "i": 10000636,
                "c": "5",
                "n": "Ожидание консолидации",
                "u": null
            },
            {
                "i": 300002,
                "c": "10",
                "n": "Ожидается оплата депозита",
                "u": null
            },
            {
                "i": 300003,
                "c": "20",
                "n": "Подтверждённый РО",
                "u": null
            },
            {
                "i": 300004,
                "c": "30",
                "n": "Подготовка документов",
                "u": null
            },
            {
                "i": 300005,
                "c": "40",
                "n": "В процессе производства",
                "u": null
            },
            {
                "i": 300006,
                "c": "50",
                "n": "Получение товара",
                "u": null
            },
            {
                "i": 300007,
                "c": "60",
                "n": "В процессе загрузки контейнера",
                "u": null
            },
            {
                "i": 300008,
                "c": "70",
                "n": "Загрузка контейнера завершена",
                "u": null
            },
            {
                "i": 300009,
                "c": "80",
                "n": "Затаможен",
                "u": null
            },
            {
                "i": 300010,
                "c": "90",
                "n": "В процессе транспортировки",
                "u": null
            },
            {
                "i": 300011,
                "c": "100",
                "n": "Доставлено до места назначения",
                "u": null
            },
            {
                "i": 300012,
                "c": "110",
                "n": "Уже завершено",
                "u": null
            }
        ],
        "i": 300
    },
    "sale_po_status_buyer": {
        "n": "",
        "s": [
            {
                "i": 454001,
                "c": "-10",
                "n": "Заказ аннулирован",
                "u": null
            },
            {
                "i": 10000637,
                "c": "5",
                "n": "Ожидание загрузки в контейнер",
                "u": null
            },
            {
                "i": 454002,
                "c": "10",
                "n": "Ожидается оплата депозита",
                "u": null
            },
            {
                "i": 454003,
                "c": "20",
                "n": "В процессе размещения",
                "u": null
            },
            {
                "i": 454004,
                "c": "40",
                "n": "Запущен в производство",
                "u": null
            },
            {
                "i": 454005,
                "c": "45",
                "n": "На проверке качества",
                "u": null
            },
            {
                "i": 454006,
                "c": "50",
                "n": "Ожидается получение на склад",
                "u": null
            },
            {
                "i": 454007,
                "c": "60",
                "n": "В процессе загрузки контейнера",
                "u": null
            },
            {
                "i": 454008,
                "c": "70",
                "n": "Загрузка завершена",
                "u": null
            },
            {
                "i": 454009,
                "c": "80",
                "n": "Прошёл таможню",
                "u": null
            },
            {
                "i": 454010,
                "c": "90",
                "n": "Товар отправлен",
                "u": null
            },
            {
                "i": 454012,
                "c": "110",
                "n": "Заказ выполнен",
                "u": null
            }
        ],
        "i": 454
    },
    "sale_type": {
        "n": "",
        "s": [
            {
                "i": 106,
                "c": "1",
                "n": "Индивидуальный",
                "u": null
            },
            {
                "i": 107,
                "c": "2",
                "n": "Представитель",
                "u": null
            }
        ],
        "i": 23
    },
    "sup_certification_type": {
        "n": "",
        "s": [
            {
                "i": 115001,
                "c": "CCC",
                "n": "ССС",
                "u": null
            },
            {
                "i": 115002,
                "c": "10P",
                "n": "10P",
                "u": null
            },
            {
                "i": 115003,
                "c": "13P",
                "n": "13P",
                "u": null
            },
            {
                "i": 115004,
                "c": "3P",
                "n": "3P",
                "u": null
            },
            {
                "i": 115005,
                "c": "6P",
                "n": "6P",
                "u": null
            },
            {
                "i": 115006,
                "c": "7P",
                "n": "7P",
                "u": null
            },
            {
                "i": 115007,
                "c": "8P",
                "n": "8P",
                "u": null
            },
            {
                "i": 115008,
                "c": "9P",
                "n": "9P",
                "u": null
            },
            {
                "i": 115009,
                "c": "ASTM_F963",
                "n": "ASTM-F963",
                "u": null
            },
            {
                "i": 115010,
                "c": "AZO",
                "n": "AZO",
                "u": null
            },
            {
                "i": 115011,
                "c": "CD",
                "n": "CD",
                "u": null
            },
            {
                "i": 115012,
                "c": "CE",
                "n": "CE",
                "u": null
            },
            {
                "i": 115013,
                "c": "C_TPAT",
                "n": "C-TPAT",
                "u": null
            },
            {
                "i": 115014,
                "c": "EMC",
                "n": "EMC",
                "u": null
            },
            {
                "i": 115015,
                "c": "EN60825",
                "n": "EN60825",
                "u": null
            },
            {
                "i": 115016,
                "c": "EN62115",
                "n": "EN62115",
                "u": null
            },
            {
                "i": 115017,
                "c": "EN71",
                "n": "EN71",
                "u": null
            },
            {
                "i": 115018,
                "c": "FCC",
                "n": "FCC",
                "u": null
            },
            {
                "i": 115019,
                "c": "GB19865",
                "n": "GB19865",
                "u": null
            },
            {
                "i": 115020,
                "c": "GB6675",
                "n": "GB6675",
                "u": null
            },
            {
                "i": 115021,
                "c": "GS",
                "n": "GS",
                "u": null
            },
            {
                "i": 115022,
                "c": "HR4040_CPSIA",
                "n": "HR4040/CPSIA",
                "u": null
            },
            {
                "i": 115023,
                "c": "ICTI",
                "n": "ICTI",
                "u": null
            },
            {
                "i": 115024,
                "c": "IEC60825",
                "n": "IEC60825",
                "u": null
            },
            {
                "i": 115025,
                "c": "ILAC",
                "n": "ILAC",
                "u": null
            },
            {
                "i": 115026,
                "c": "ISO8124",
                "n": "ISO8124",
                "u": null
            },
            {
                "i": 115027,
                "c": "PB",
                "n": "PB",
                "u": null
            },
            {
                "i": 115028,
                "c": "PHTHALATES",
                "n": "PHTHALATES",
                "u": null
            },
            {
                "i": 115029,
                "c": "R_TTE",
                "n": "R&TTE",
                "u": null
            },
            {
                "i": 115030,
                "c": "REACH",
                "n": "REACH",
                "u": null
            },
            {
                "i": 115031,
                "c": "ROHS",
                "n": "ROHS",
                "u": null
            },
            {
                "i": 115032,
                "c": "SGS",
                "n": "SGS",
                "u": null
            },
            {
                "i": 115033,
                "c": "UK",
                "n": "Сертификат UK",
                "u": null
            },
            {
                "i": 115034,
                "c": "USP51",
                "n": "USP51",
                "u": null
            },
            {
                "i": 115035,
                "c": "USP61_62",
                "n": "USP61.62",
                "u": null
            },
            {
                "i": 1000236,
                "c": "PAHS",
                "n": "PAHS",
                "u": null
            },
            {
                "i": 1000237,
                "c": "EN62471",
                "n": "EN62471",
                "u": null
            },
            {
                "i": 1000238,
                "c": "BIS",
                "n": "BIS",
                "u": null
            },
            {
                "i": 1000241,
                "c": "GCC",
                "n": "GCC",
                "u": null
            },
            {
                "i": 1000366,
                "c": "CPC",
                "n": "CPC",
                "u": null
            },
            {
                "i": 4680342,
                "c": "SCCP",
                "n": "SCCP",
                "u": null
            },
            {
                "i": 4680343,
                "c": "CPSC",
                "n": "CPSC",
                "u": null
            },
            {
                "i": 4680344,
                "c": "SVHC",
                "n": "SVHC",
                "u": null
            },
            {
                "i": 4680345,
                "c": "California_65",
                "n": "California 65",
                "u": null
            },
            {
                "i": 4680346,
                "c": "Hexaphenylbenzene",
                "n": "Hexaphenylbenzene",
                "u": null
            },
            {
                "i": 4680347,
                "c": "EU_total_cadmium",
                "n": "欧盟总镉",
                "u": null
            }
        ],
        "i": 115
    },
    "unit_type": {
        "n": "",
        "s": [
            {
                "i": 699001,
                "c": "he",
                "n": "Коробка",
                "u": null
            },
            {
                "i": 699002,
                "c": "dai",
                "n": "Пакет",
                "u": null
            },
            {
                "i": 699003,
                "c": "nx",
                "n": "Внутренняя коробка",
                "u": null
            },
            {
                "i": 699004,
                "c": "wx",
                "n": "Внешний короб",
                "u": null
            },
            {
                "i": 699007,
                "c": "bao",
                "n": "Упаковка",
                "u": null
            },
            {
                "i": 699008,
                "c": "pian",
                "n": "Шт.",
                "u": null
            },
            {
                "i": 699009,
                "c": "ka",
                "n": "Карта",
                "u": null
            },
            {
                "i": 699010,
                "c": "tiao",
                "n": "Шт.",
                "u": null
            },
            {
                "i": 699011,
                "c": "PCS",
                "n": "Шт.",
                "u": null
            },
            {
                "i": 699012,
                "c": "guan",
                "n": "шт.",
                "u": null
            },
            {
                "i": 699013,
                "c": "jia",
                "n": "Полка",
                "u": null
            },
            {
                "i": 699014,
                "c": "lan",
                "n": "Корзинка",
                "u": null
            },
            {
                "i": 10001679,
                "c": "ge",
                "n": "шт.",
                "u": null
            }
        ],
        "i": 699
    },
    "wallet_withdraw_item_handle_remark_code": {
        "n": "",
        "s": [
            {
                "i": 999001,
                "c": "10",
                "n": "Реквизиты банковского счета неверны и не могут быть урегулированы",
                "u": null
            },
            {
                "i": 999002,
                "c": "20",
                "n": "Запрос отклоняется консенсусом.",
                "u": null
            }
        ],
        "i": 999
    }
}
 export default dicts;